export default __webpack_public_path__ + "static/media/floor-16_2.9eaf135e.jpg";